module.exports = __webpack_public_path__ + "img/xiaban.f5deb5e7.png";